
<div   class=" loginWrap signin-div"  [ngStyle]="{ 'background': 'url(&quot;' + loginbg + '&quot;) no-repeat center center','background-size': '100%' }" style="height: 100%">

  <div class="container login-sec">
    <div class="new-sign-sec">
      <div class="row col-md-5 col-sm-12 fltnon pad0" style="margin-top:25px;">
        <div class="sign-up-front dflex">
          <div class="col-md-10 col-sm-6 col-xs-12 distblcel">
            <div class="panel panel-default brdnone">

              <div class="panel-body">
                <!-- <form id="signupId" style="margin-top: 50px;margin-bottom: 150px;">
                  <div class="">
                    <div class="row">
                      <p style="text-align: center;margin-bottom: 15px;font-weight: bold;">OTP VERIFICATION</p>

                      <p style="text-align: center;margin-bottom: 35px;margin-top: 30px">Please enter the verification code <br>sent your email</p>
                    </div>
                  </div>

                  <div class="form-group float-label-control">

                    <input type="text" class="form-control" autocomplete="off" placeholder="Enter OTP" name="userName" [(ngModel)]="otpvalue" (keyup)="userAvail(otpvalue)" maxlength="6" minlength="6">

                    <div class="pad1">
                      <span class="text-danger" *ngIf="limitError">
                        <i class="fa fa-times mar1" aria-hidden="true"></i> Minimum length value is 6</span>
                    </div>
                  </div>

                  <div class="clearfix"></div>


                  <div class="text-danger" style="margin-bottom: 10px;">
                    {{errormsg}}
                  </div>

                  <div class="form-group clearfix">
                    <p class="text-center loder">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </p>

                      <button type="button" class="btn btn-3 btnPadding btn-primary btn-block createAccbtn" (click)="verifyOtp()" [disabled]="limitError">SUBMIT</button>

                  </div>
                  <div class="text-center">Already have an account?
                    <a [routerLink]="[url]" (click)="clearerrormsg()">Login</a>
                  </div>

                </form> -->

                <div class="">
                  <div class="row">
                    <p style="text-align: center;margin-bottom: 15px;font-weight: bold;margin-top: 20px;">StatementGames New Account <br>Verification Code</p>

                    <p style="text-align: center;margin-bottom: 35px;margin-top: 30px">Please enter the 6 digit new registration verification code sent to the email you provided during registration</p>

                    <p class="blink">Do not close or refresh your browser at this time.</p>

                  </div>
                </div>

                <!-- <p style="text-align: left;margin-bottom: 10px;margin-top: 10px">Enter OTP</p> -->
                <form [formGroup]="registerForm" (ngSubmit)="verifyOtp()">
                <table>
                  <tr>
                    <td style="padding: 5px!important;">
                      <input type="text" #Field1 formControlName="otp1" class="form-control" autocomplete="off" name="1" (keyup)="userAvail($event,Field2,Field1)" maxlength="1" minlength="1">
                    </td>
                    <td style="padding: 5px!important;">
                      <input type="text" #Field2 formControlName="otp2" class="form-control" autocomplete="off" name="2" (keyup)="userAvail($event,Field3,Field1)" maxlength="1" minlength="1">
                    </td>

                    <td style="padding: 5px!important;">
                      <input type="text" #Field3 formControlName="otp3"  class="form-control" autocomplete="off" name="3" (keyup)="userAvail($event, Field4, Field2)" maxlength="1" minlength="1">
                    </td>

                    <td style="padding: 5px!important;">
                      <input type="text" #Field4 formControlName="otp4" class="form-control" autocomplete="off" name="4" (keyup)="userAvail($event, Field5, Field3)" maxlength="1" minlength="1">
                    </td>

                    <td style="padding: 5px!important;">
                      <input type="text" #Field5 formControlName="otp5" class="form-control" autocomplete="off" name="5" (keyup)="userAvail($event, Field6, Field4)" maxlength="1" minlength="1">
                    </td>

                    <td style="padding: 5px!important;">
                      <input type="text" #Field6 formControlName="otp6"  class="form-control" autocomplete="off" name="6" maxlength="1" minlength="1" (keyup)="userAvail($event, Field6 , Field5)">
                    </td>

                  </tr>
                </table>
                <!-- <p>{{message}}</p> -->
                <div class="text-success" style="margin-bottom: 10px;">
                  {{message}}
                </div>

                <div class="text-danger" style="margin-bottom: 10px;">
                  {{errormsg}}
                </div>


                <div class="form-group clearfix" style="float: right;">
                  <p class="text-center loder1">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                  </p>
                  <button type="button" style="float: right; border: 0px; background-color: transparent;" (click)="resendOtp()"><p style="text-align: right;margin-bottom: 20px;margin-top: 20px; color:green; font-weight: 600;">Resend Code</p></button>
                </div>

                <div class="form-group clearfix">
                  <p class="text-center loder">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                  </p>

                    <button type="button" class="btn btn-3 btnPadding btn-primary btn-block createAccbtn"  [disabled]="!registerForm.valid" (click)="verifyOtp()">SUBMIT</button>

                </div>
              </form>
                <div class="text-center" style="margin-bottom:30px;">Already have an account?
                  <a routerLink="/landing/signin">Login</a>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="col-md-7 col-sm-6 col-xs-12 signin-video pad0  signin-div sign-bg-img "
          style="float:right;">
          <div class="btn-im video-sec pad0">
              <div  class="video-wrap reveal">
                  <a *ngIf="youtubevideo != undefined && youtubevideo != null && videoplay == false  && youtubevideo != '' && youtubevideo != 'null'" (click)="video()">
                      <i aria-hidden="true" class="fa fa-play video-icon">
                      </i>
                      <div class="video-wrap-overlay"></div>
                  </a>
                  <iframe  *ngIf="videoplay == true" width="580" height="330" class="frme-wdth" frameborder="0" wmode="Opaque" allowfullscreen="" [src]="youtubevideo" id="t-video" style="margin: 15px auto;width: 550px;"></iframe>
              </div>
          </div>
      </div> -->

        </div>
      </div>
    </div>
  </div>
</div>
